import { FadeUp, Eyebrow } from "@/components/reveal";

const FOUNDER_IMG = "/founder-eshaa.jpg";

const Founder = () => (
    <section
        id="founder"
        data-testid="founder-section"
        className="py-24 lg:py-32"
    >
        <div className="container-x grid items-center gap-14 lg:grid-cols-12">
            <div className="lg:col-span-4 lg:col-start-2">
                <FadeUp className="relative">
                    <div
                        className="absolute inset-0 -translate-x-3 translate-y-3 border border-olive/40"
                        aria-hidden="true"
                    />
                    <div className="relative aspect-[4/5] overflow-hidden">
                        <img
                            data-testid="founder-portrait"
                            src={FOUNDER_IMG}
                            alt="Eshaa Joshi, Founder of Everlast Partners"
                            className="h-full w-full object-cover"
                        />
                        <div
                            className="absolute inset-0 bg-olive/10 mix-blend-multiply"
                            aria-hidden="true"
                        />
                    </div>
                </FadeUp>
            </div>

            <div className="lg:col-span-6">
                <FadeUp>
                    <Eyebrow>Founder</Eyebrow>
                </FadeUp>
                <FadeUp delay={0.1}>
                    <h2 className="mt-6 font-serif text-5xl tracking-tight sm:text-6xl">
                        Eshaa Joshi
                    </h2>
                </FadeUp>
                <FadeUp delay={0.15}>
                    <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.25em] text-olive">
                        Founder
                    </p>
                </FadeUp>
                <FadeUp delay={0.2}>
                    <p className="mt-8 max-w-xl text-lg leading-relaxed text-inksoft sm:text-xl">
                        Eshaa advises governments, port authorities, investors and
                        innovation hubs on infrastructure strategy — connecting
                        public ambition with private capital across ports, shipping
                        and the energy transition.
                    </p>
                </FadeUp>
                <FadeUp delay={0.25}>
                    <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.22em] text-inkmut">
                        Cambridge, MA · Pune
                    </p>
                </FadeUp>
            </div>
        </div>
    </section>
);

export default Founder;
